import React from "react";
import './ChatRecipientIcon.css'
const ChatRecipientIcon = ({ children }) => {
  return <span className="chat__recipientIcon">{children}</span>;
};

export default ChatRecipientIcon;